import React, { forwardRef, useState } from 'react';
import MaterialTable from 'material-table';
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles';
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
// import ExportConfiguration from './ExportConfiguration';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const DataTable = forwardRef((props, ref) => {
  const {
    exportOnClick,
    exportColumns,
    exportFilename,
    exportHeaders,
    columns,
    data,
    selectionProps: varSelectionProps,
    search,
    selection: varSelection,
    toolbar: varToolbar,
    isLoading,
    components,
    setSelectedRows,
    export: varExport,
    rowBackgroundColor,
    title,
    isRemoteData
  } = props;

  const theme = createMuiTheme({
    palette: {
      secondary: {
        main: '#3f51b5',
        light: '#3f51b5',
        dark: '#3f51b5',
      },
    },
  });

  // Build options object
  const tableOptions = {
    selection: varSelection,
    selectionProps: varSelectionProps,
    filtering: search,
    pageSize: 25,
    // pageSizeOptions: [10, 25, 50, 100],
    pageSizeOptions: [25],
    draggable: false,
    searchAutoFocus: true,
    toolbar: varToolbar,
    paging: true,
    search: false,
    debounceInterval: 0,
    emptyRowsWhenPaging: false,
    rowStyle: () => ({
      backgroundColor: rowBackgroundColor ?? '#EEE',
    }),
    headerStyle: { color: '#000000', fontWeight: 'bolder', zIndex: 0 },
  };

  return (
    <MuiThemeProvider theme={theme}>
      {/* TODO setup later */}
      {/* {typeof varExport !== 'undefined' && varExport === true ? (
        <ExportConfiguration
          exportOnClick={exportOnClick}
          exportHeader={exportHeaders}
          exportColumns={exportColumns}
          exportFilename={exportFilename}
        />
      ) : (
        <></>
      )} */}
      <MaterialTable
        tableRef={ref}
        columns={columns}
        icons={tableIcons}
        data={data}
        title={title}
        options={tableOptions}
        onSelectionChange={(row) => {
          setSelectedRows(row);
        }}
        components={components}
        isLoading={typeof isLoading === 'undefined' ? false : isLoading}
      />
    </MuiThemeProvider>
  );
});

export default DataTable;
